module.exports = __webpack_public_path__ + "static/shipracer-logo.b7c0acd2.png";